export const IStatusScreenViewModelType = Symbol('IStatusScreenViewModel');
